/***
 *
 *   DATE INPUT
 *   A native <input type="date">: emits "YYYY-MM-DD" ("" when cleared), takes
 *   min/max as "YYYY-MM-DD" or { year, month, day }, and shows the form's
 *   error state like the other inputs.
 *
 *   It replaced react-modern-calendar-datepicker, whose Calendar removes its
 *   keyup listener through a ref React 17 has already nulled when the calendar
 *   closes, so picking a day threw "Cannot read properties of null (reading
 *   'removeEventListener')". The native input also lets a date of birth be
 *   typed and cleared directly.
 *
 **********/

import React from 'react';
import { Label, Error, ClassHelper } from 'components/lib';
import Style from '../input.tailwind.js';

const pad = (n) => String(n).padStart(2, '0');

// "YYYY-MM-DD" or { year, month, day } -> "YYYY-MM-DD" (undefined if absent)
export function toIsoDate(value){

  if (!value) return undefined;
  if (typeof value === 'string') return value.split('T')[0];
  if (value.year && value.month && value.day)
    return `${value.year}-${pad(value.month)}-${pad(value.day)}`;
  return undefined;

}

export function DateInput(props){

  const error = props.errorMessage || 'Please enter a valid date';

  function change(e){

    const value = e.target.value; // "YYYY-MM-DD", or "" when cleared or incomplete
    let valid;

    if (props.required)
      valid = value !== '';

    props.onChange?.(props.name, value, valid);

  }

  const dateStyle = ClassHelper(Style, {

    textbox: true,
    className: props.className,
    error: props.valid === false,
    success: props.valid === true,

  });

  return (
    <div className={ Style.input }>

      { props.label &&
        <Label
          text={ props.label }
          required={ props.required }
          for={ props.name }
        /> }

      <input
        type='date'
        id={ props.id || props.name }
        name={ props.name }
        value={ toIsoDate(props.value) || '' }
        min={ toIsoDate(props.min) }
        max={ toIsoDate(props.max) }
        className={ dateStyle }
        onChange={ change }
      />

      { props.valid === false &&
        <Error message={ error }/> }

    </div>
  );
}
